import type { HTMLAttributes } from 'react';

export const SectionCaption = ({ className = '', ...rest }: HTMLAttributes<HTMLParagraphElement>) =>
  <p className={`text-caption-1 mt-0.5 ${className}`} {...rest} />;
